import AIImpactThumbnail from "../images/articles/ai-impact-on-developers.webp";
import NotLandingInterviewsThumbnail from "../images/articles/not-landing-interviews.webp";
import DoIReallyNeedACoverLetterThumbnail from "../images/articles/do-i-really-need-a-cover-letter.webp";
import PerfectApplicantThumbnail from "../images/articles/perfectApplicant.webp";
import HowNewDevsShouldBeUsingAIThumbnail from "../images/articles/how-new-devs-should-be-using-ai.webp";
import TutorialHellThumbnail from "../images/articles/tutorial-hell.webp";
import ApplyForJobsThumbnail from "../images/articles/apply-for-jobs.webp";
import AcingYourCodingInterview from "../images/articles/acing-your-coding-interview.webp";
import LearnFasterThan90DevsThumbnail from "../images/articles/learn-faster-than-90-devs.webp";
import {Article} from "../models/Article";
import {COVER_LETTER_FOR_TECH_JOB_CONTENT_MARKUP} from "./articles/CoverLetterForTechJob";
import {AIS_IMPACT_ON_DEVELOPERS_CONTENT_MARKUP} from "./articles/AIsImpactOnDevelopers";
import {NOT_LANDING_INTERVIEWS_CONTENT_MARKUP} from "./articles/NotLandingInterviewsTest";
import {YOULL_NEVER_BE_THE_PERFECT_APPLICANT_CONTENT_MARKUP} from "./articles/YoullNeverBeThePerfectApplicant";
import {THE_REAL_WAY_NEW_DEVELOPERS_SHOULD_BE_USING_AI_TOOLS_CONTENT_MARKUP} from "./articles/TheRealWayNewDevelopersShouldBeUsingAITools";
import {FROM_TUTORIAL_HELL_TO_CODING_WITH_CONFIDENCE_CONTENT_MARKUP} from "./articles/FromTutorialHellToCodingWithConfidence";
import {FIVE_SIGNS_YOURE_READY_TO_APPLY_FOR_CODING_JOBS_CONTENT_MARKUP} from "./articles/FiveSignsYoureReadyToApplyForCodingJobs";
import {FIVE_KEYS_TO_ACING_YOUR_CODING_INTERVIEW_CONTENT_MARKUP} from "./articles/FiveKeysToAcingYourCodingInterview";
import {LEARN_FASTER_THAN_90_DEVS_CONTENT_MARKUP} from "./articles/LearnFasterThan90Devs";

export const ARTICLES_MARKUP = [
    new Article(
        "How to Learn Faster Than 90% of Other New Developers",
        "A lot of beginners measure their progress by hours. The more tutorials you watch, the faster you'll improve, right? Not exactly. Two people can both spend 100 hours learning to code. One will be job-ready. The other will still be stuck in tutorial hell.",
        LearnFasterThan90DevsThumbnail,
        "how-to-learn-faster-than-90-percent-of-other-new-developers",
        LEARN_FASTER_THAN_90_DEVS_CONTENT_MARKUP,
        "August 26, 2025",
        "LearnFasterThan90Devs",
        false
    ),
    new Article(
        "5 Keys to Acing Your Coding Interview (That Have Nothing to Do With Code)",
        "A lot of new developers think coding interviews are about one thing: writing flawless code on the spot. The truth is, most interviewers aren't just looking at whether your solution compiles.",
        AcingYourCodingInterview,
        "five-keys-to-acing-your-coding-interview",
        FIVE_KEYS_TO_ACING_YOUR_CODING_INTERVIEW_CONTENT_MARKUP,
        "August 19, 2025",
        "FiveKeysToAcingYourCodingInterview",
        false
    ),
    new Article(
        "5 Signs You're Ready to Apply for Coding Jobs (Even if You Don't Feel Ready)",
        "A lot of new developers wait way too long before applying for jobs. They think they need to master every framework, build a dozen 'perfect' portfolio projects, and know every algorithm ever written before they even click 'Apply.'",
        ApplyForJobsThumbnail,
        "five-signs-youre-ready-to-apply-for-coding-jobs",
        FIVE_SIGNS_YOURE_READY_TO_APPLY_FOR_CODING_JOBS_CONTENT_MARKUP,
        "August 12, 2025",
        "FiveSignsYoureReadyToApplyForCodingJobs",
        false
    ),
    new Article(
        "From Tutorial Hell to Coding with Confidence",
        "If you've been learning to code for a while, you probably know the cycle: Watch a tutorial, follow along line-by-line, nod as everything makes sense, finish… and realize you couldn't recreate it without the video.",
        TutorialHellThumbnail,
        "from-tutorial-hell-to-coding-with-confidence",
        FROM_TUTORIAL_HELL_TO_CODING_WITH_CONFIDENCE_CONTENT_MARKUP,
        "August 5, 2025",
        "FromTutorialHellToCodingWithConfidence",
        false
    ),
    new Article(
        "The Real Way New Developers Should Be Using AI Tools",
        "AI tools have become a hot topic among developers. Some people treat them as magic wands that will instantly make them better programmers. Others see them as the end of learning altogether.",
        HowNewDevsShouldBeUsingAIThumbnail,
        "the-real-way-new-developers-should-be-using-ai-tools",
        THE_REAL_WAY_NEW_DEVELOPERS_SHOULD_BE_USING_AI_TOOLS_CONTENT_MARKUP,
        "July 27, 2025",
        "TheRealWayNewDevelopersShouldBeUsingAITools",
        false
    ),
    new Article(
        "You'll Never Be The Perfect Applicant",
        "Ive been a professional developer for 10+ years, worked from starts ups all the way to FAANGs, and I've never been qualified for a job I was hired for.",
        PerfectApplicantThumbnail,
        "youll-never-be-the-perfect-applicant",
        YOULL_NEVER_BE_THE_PERFECT_APPLICANT_CONTENT_MARKUP,
        "July 20, 2025",
        "YoullNeverBeThePerfectApplicant",
        false
    ),
    new Article(
        "Do I really need a cover letter for a tech job?",
        "Let’s be honest. Job searching these days can be awful. You find a job to apply for. You upload your resume. You then manually enter all of the information that is already on your resume...",
        DoIReallyNeedACoverLetterThumbnail,
        "cover-letter-for-a-tech-job",
        COVER_LETTER_FOR_TECH_JOB_CONTENT_MARKUP,
        "June 20, 2025",
        "CoverLetterForATechJob",
        false
    ),
    new Article(
        "Not Landing Interviews? See If Your Tech Resume Passes This Quick Test",
        "You ask a group of programmers, “What’s the worst part of job searching?”. What do you think they’ll say?",
        NotLandingInterviewsThumbnail,
        "not-landing-interviews-test",
        NOT_LANDING_INTERVIEWS_CONTENT_MARKUP,
        "May 20, 2025",
        "NotLandingInterviewsTest",
        false
    ),
    new Article(
        "AI's Impact on Future Software Developers",
        "It's no secret: AI is currently changing our world. And with these changes, I hear one question over and over again.. \"Will AI replace software developers?\"",
        AIImpactThumbnail,
        "ais-impact-on-developers",
        AIS_IMPACT_ON_DEVELOPERS_CONTENT_MARKUP,
        "April 20, 2025",
        "AiImpactOnSoftwareDevelopers",
        false
    )
]